import angularJsUtilitiesModule from "../angularJsUtilitiesModule";
import { Hybrid } from "Roblox";

function hybridService($log) {
    "ngInject";
        function isHybridValid() {
            return Hybrid;
        }

        return {
            startChatConversation: function (params, callback) { // Android
                if (isHybridValid() && Hybrid.Chat) {
                    if (angular.isUndefined(callback)) {
                        callback = function () {}
                    }
                    Hybrid.Chat.startChatConversation(params, callback);
                }
            },

            startWebChatConversation: function (params, callback) { // iOS
                if (isHybridValid() && Hybrid.Navigation) {
                    if (angular.isUndefined(callback)) {
                        callback = function () { }
                    }
                    Hybrid.Navigation.startWebChatConversation(params, callback);
                }
            },

            navigateToFeature: function (params, callback) {
                if (isHybridValid() && Hybrid.Navigation) {
                    if (angular.isUndefined(callback)) {
                        callback = function () { }
                    }
                    Hybrid.Navigation.navigateToFeature(params, callback);
                }
            },

            openUserProfile: function (params, callback) {
                if (isHybridValid() && Hybrid.Navigation) {
                    if (angular.isUndefined(callback)) {
                        callback = function () { }
                    }
                    Hybrid.Navigation.openUserProfile(params, callback);
                }
            },

            close: function (callback) {
                if (isHybridValid() && Hybrid.Overlay) {
                    if (angular.isUndefined(callback)) {
                        callback = function () { }
                    }
                    Hybrid.Overlay.close(callback);
                }
            },

            launchGame: function (params, callback) {
                if (isHybridValid() && Hybrid.Game) {
                    if (angular.isUndefined(callback)) {
                        callback = function () { }
                    }

                    Hybrid.Game.launchGame(params, callback);
                }
            }
    }
};
angularJsUtilitiesModule.factory("hybridService", hybridService);

export default hybridService;